import { useMemo } from 'react';

import Cookies from 'js-cookie';

import useMagicIdWallet from '@shared/hooks/useMagicIdWallet';

export interface StoredSnapshotVoteParams {
  appId: string;
  account: string;
  proposalId: string;
  choice: number;
  reason?: string;
}

export const getStoredSnapshotVote = ({
  appId,
  account,
  proposalId,
}: Pick<StoredSnapshotVoteParams, 'appId' | 'account' | 'proposalId'>) => {
  const name = `vote:${appId}/${account?.toLowerCase()}/${proposalId?.toLowerCase()}`;
  const storedVoteRaw = Cookies.get(name);

  return storedVoteRaw ? Number(storedVoteRaw) : null;
};

export const storeSnapshotVote = ({
  appId,
  account,
  proposalId,
  choice,
}: StoredSnapshotVoteParams) => {
  const name = `vote:${appId}/${account?.toLowerCase()}/${proposalId?.toLowerCase()}`;

  Cookies.set(name, String(choice), {
    expires: 1 / 24, // 1 hour
  });
};

export const useSnapshotStoredVote = ({
  appId,
  proposalId,
}: Pick<StoredSnapshotVoteParams, 'appId' | 'proposalId'>) => {
  const { userWallet } = useMagicIdWallet();

  return useMemo(() => {
    if (!userWallet) {
      return null;
    }

    return getStoredSnapshotVote({
      appId,
      proposalId,
      account: userWallet.attributes.address,
    });
  }, [appId, proposalId, userWallet]);
};
